"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MouseClickHandler = (function () {
    function MouseClickHandler() {
    }
    MouseClickHandler.registerEvent = function (grid, event, condition, action) {
        if (!condition || !action) {
            return;
        }
        var cell = MouseClickHandler.getCell(grid, event);
        if (cell) {
            var oldValue = grid.model.get(cell.x, cell.y);
            if (condition(oldValue)) {
                var newValue = action(oldValue);
                grid.model.put(cell.x, cell.y, newValue);
            }
        }
    };
    MouseClickHandler.getCell = function (grid, event) {
        try {
            var cellArray = grid.cellByLocation(event.x, event.y);
            if (!cellArray) {
                return undefined;
            }
            return { x: cellArray[0], y: cellArray[1] };
        }
        catch (error) {
        }
    };
    return MouseClickHandler;
}());
exports.MouseClickHandler = MouseClickHandler;
//# sourceMappingURL=mouseClickHandler.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/mouseClickHandler.js
// module id = 79
// module chunks = 0